export default "__VITE_ASSET__BCEFJXqK__"